import { Box, Typography, useTheme } from '@mui/material';
import { styled } from '@mui/system';

import { MessageStyleProps } from './types';

export const MessageContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isOwnMessage',
})(({ isOwnMessage }: MessageStyleProps) => {
  const theme = useTheme();
  return {
    display: 'flex',
    flexDirection: 'column',
    alignItems: isOwnMessage ? 'flex-end' : 'flex-start',
    marginBottom: theme.spacing(2),
  };
});

export const MessageBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isOwnMessage',
})(({ isOwnMessage }: MessageStyleProps) => {
  const theme = useTheme();
  return {
    backgroundColor: isOwnMessage ? theme.palette.primary.main : theme.palette.grey[200],
    color: isOwnMessage ? 'white' : 'black',
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    maxWidth: '70%',
    wordBreak: 'break-word',
  };
});

export const MessageDetails = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginTop: theme.spacing(1),
}));

export const TimeStamp = styled(Typography)(({ theme }) => ({
  marginLeft: theme.spacing(1),
  color: theme.palette.text.secondary,
  fontSize: '0.75rem',
}));
